import { Component } from '@angular/core';

@Component({
  selector: 'app-user-routing',
  templateUrl: './user-routing.component.html',
  styleUrls: ['./user-routing.component.scss']
})
export class UserRoutingComponent {

}
